// Caches the user's last-known GPS position (updated in the background) so it can be
// attached as an `X-Geo` header on every action request for audit trails.
let last = null;

export function startGeoWatch() {
  if (!("geolocation" in navigator)) return;
  try {
    navigator.geolocation.getCurrentPosition(setPos, () => {}, { timeout: 8000, maximumAge: 60000 });
    navigator.geolocation.watchPosition(setPos, () => {}, { timeout: 15000, maximumAge: 60000 });
  } catch (e) { /* ignore */ }
}

function setPos(p) {
  last = { lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy };
}

export function geoHeader() {
  if (!last) return null;
  return `${last.lat},${last.lng},${Math.round(last.accuracy || 0)}`;
}
